export enum ContentColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Muted = 'muted',
  Transparent = 'transparent',
  White = 'white',
  Black = 'black',
  PrimaryLight = 'primary-light',
  SecondaryLight = 'secondary-light',
  // Text colors
  ThemeText = 'theme-text',

}
